module.exports = __webpack_public_path__ + "static/media/finished_blue.2e33dc0e.svg";